export var LoggedOutCategoryResultsBanner;
(function(LoggedOutCategoryResultsBanner) {
    LoggedOutCategoryResultsBanner[LoggedOutCategoryResultsBanner["FILTER_PILL_TILE"] = 0] = "FILTER_PILL_TILE";
    LoggedOutCategoryResultsBanner[LoggedOutCategoryResultsBanner["SIGN_UP_PRODUCT_GRID_BANNER"] = 1] = "SIGN_UP_PRODUCT_GRID_BANNER";
})(LoggedOutCategoryResultsBanner || (LoggedOutCategoryResultsBanner = {}));
